"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FlyingLetter_1 = require("./FlyingLetter");
exports.default = FlyingLetter_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Loader/components/FlyingLetter/index.js
// module id = 1202
// module chunks = 8